// @flow

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  withRouter
} from 'react-router-dom';
import styled, {
  css,
  injectGlobal,
  ThemeProvider
} from 'styled-components';

// Config
import baartTheme from './config/themes/baart';
import colors from './config/colors';
import settings from './config/settings';

// Components
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Sidebar from './components/Sidebar';

// Views
import About from './views/About';
import Contact from './views/Contact';
import Home from './views/Home';
import NotFound from './views/NotFound';
import SignUp from './views/SignUp';
import Support from './views/Support';
import Vortex from './views/tools/vortex';

injectGlobal`
  :root {
    box-sizing: border-box;
    line-height: 1.6em;
    -webkit-font-smoothing: antialiased;
  }
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    color: ${colors.text.normal};
    font-size: ${settings.fontSize};
    font-family: ${settings.font};
    padding: ${settings.headerHeight} 0 ${settings.footerHeight};
  }
  h1, h2, h3, h4, h5, h6 {
    color: ${colors.headings};
    font-family: ${settings.font};
  }
  a {
    color: #000000;
  }
  fieldset  {
    border: 0;
    margin: 0;
    padding: 0;
  }
`;

const Main = styled.div`
  left: ${props => props.navRevealed ? `calc(-100% + ${settings.navSize})` : 0};
  position: relative;
  ${settings.navTransition && css`transition: ${settings.navTransition};`}
`;

const appendTitle = ' | Baart Tools';

const HeaderWithRouter = withRouter(Header);

type State = {
  appTitle: string,
  navRevealed: boolean
}

class App extends Component<{}, State> {

  state = {
    appTitle: 'Baart Tools',
    navRevealed: false
  }

  navSelected = () => {
    this.toggleNav(false);
  }

  titleChanged = ({ title }: { title: string }) => {
    const appTitle = title.replace(appendTitle, '');
    this.setState({ appTitle });
  }

  toggleNav = (navRevealed: ?boolean = null) => {
    if (navRevealed === null) {
      navRevealed = !this.state.navRevealed;
    }
    this.setState({ navRevealed });
  }

  render() {
    const { navRevealed } = this.state;
    return (
      <Router>
        <ScrollToTop>
          <div className="router">
            <Helmet
              defaultTitle="Welcome to Baart Tools"
              onChangeClientState={this.titleChanged}
              titleTemplate={`%s${appendTitle}`}
            />
            <ThemeProvider theme={baartTheme}>
              <Main navRevealed={navRevealed}>
                <HeaderWithRouter
                  navRevealed={navRevealed}
                  title={this.state.appTitle}
                  toggleNav={() => this.toggleNav()}
                />
                <Switch>
                  <Route path="/" component={Home} exact={true} />
                  <Route path="/about" component={About} exact={true} />
                  <Route path="/contact" component={Contact} exact={true} />
                  <Route path="/support" component={Support} exact={true} />
                  <Route path="/sign-up" component={SignUp} exact={true} />
                  <Route path="/tools/vortex" component={Vortex} exact={false} />
                  <Route component={NotFound} />
                </Switch>
              </Main>
            </ThemeProvider>
            <Sidebar
              navRevealed={navRevealed}
              navSelected={this.navSelected}
            />
            <Footer navRevealed={navRevealed} />
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js